import 'fomantic-ui-less/definitions/globals/reset.less';
import 'fomantic-ui-less/definitions/globals/site.less';

import 'fomantic-ui-less/definitions/elements/button.less';
import 'fomantic-ui-less/definitions/elements/container.less';
import 'fomantic-ui-less/definitions/elements/divider.less';
import 'fomantic-ui-less/definitions/elements/header.less';
import 'fomantic-ui-less/definitions/elements/icon.less';
import 'fomantic-ui-less/definitions/elements/image.less';
import 'fomantic-ui-less/definitions/elements/input.less';
import 'fomantic-ui-less/definitions/elements/label.less';
import 'fomantic-ui-less/definitions/elements/list.less';
import 'fomantic-ui-less/definitions/elements/segment.less';
import 'fomantic-ui-less/definitions/elements/loader.less';
import 'fomantic-ui-less/definitions/elements/text.less';
import 'fomantic-ui-less/definitions/elements/reveal.less';

import 'fomantic-ui-less/definitions/collections/breadcrumb.less';
import 'fomantic-ui-less/definitions/collections/form.less';
import 'fomantic-ui-less/definitions/collections/grid.less';
import 'fomantic-ui-less/definitions/collections/menu.less';
import 'fomantic-ui-less/definitions/collections/message.less';
import 'fomantic-ui-less/definitions/collections/table.less';

import 'fomantic-ui-less/definitions/views/card.less';
import 'fomantic-ui-less/definitions/views/item.less';
import 'fomantic-ui-less/definitions/views/statistic.less';

import 'fomantic-ui-less/definitions/modules/transition.less';
import 'fomantic-ui-less/definitions/modules/accordion.less';
import 'fomantic-ui-less/definitions/modules/dimmer.less';
import 'fomantic-ui-less/definitions/modules/modal.less';
import 'fomantic-ui-less/definitions/modules/search.less';
import 'fomantic-ui-less/definitions/modules/dropdown.less';
import 'fomantic-ui-less/definitions/modules/checkbox.less';
import 'fomantic-ui-less/definitions/modules/popup.less';
import 'fomantic-ui-less/definitions/modules/sticky.less';
import 'fomantic-ui-less/definitions/modules/progress.less';

import 'fomantic-ui-less/definitions/behaviors/api';

import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/accordion';
import 'fomantic-ui-less/definitions/modules/search';
import 'fomantic-ui-less/definitions/modules/dropdown';
import 'fomantic-ui-less/definitions/modules/popup';
import 'fomantic-ui-less/definitions/modules/sticky';

import '@github/relative-time-element';

import '@mdi/svg/svg/chevron-down.svg';
import '@mdi/svg/svg/chevron-left.svg';
import '@mdi/svg/svg/chevron-double-left.svg';
import '@mdi/svg/svg/chevron-right.svg';
import '@mdi/svg/svg/dots-horizontal.svg';
import '@mdi/svg/svg/magnify.svg';
import '@mdi/svg/svg/web.svg';

import {dataCopyValue} from './Common/copyToClipboard';
import {setupCloseableMessages} from './Common/message';
import {setupPublicLaunchSettings} from './Common/publicLaunchSettings';
import {setupSubmitFormLinks} from './Common/submitFormLinks';

window.enableSimWorkflowLog = () => localStorage.setItem("simworkflow.log", "all");
window.disableSimWorkflowLog = () => localStorage.removeItem("simworkflow.log");

$(document).ready(() => {
    document.querySelectorAll('.ui.dropdown').forEach(dropdown => {
        if (dropdown.closest('.page-footer, #page-menu, .markdown-body.task, table[data-id][data-tasks], div.column[data-id][data-tasks]')) {
            return;
        }

        const settings = {
            duration: 0
        };

        if (dropdown.id === 'page-header-dropdown') {
            settings.action = 'nothing';
            settings.selectOnKeydown = false;
        }

        if (dropdown.classList.contains('search')) {
            settings.fullTextSearch = true;
        }

        if (dropdown.classList.contains('clearable')) {
            settings.clearable = true;
        }

        if (dropdown.classList.contains('addition') || dropdown.classList.contains('additions')) {
            settings.allowAdditions = true;
            settings.showNoResults = false;
        }

        $(dropdown).dropdown(settings);
    });
    setupCloseableMessages(document);
    setupPublicLaunchSettings(document);
    setupSubmitFormLinks(document);
    dataCopyValue();
});
